import * as React from 'react';
import cx from 'classnames';
import { throttle } from 'lodash';

import EventTracking from 'lib/EventTracking';

import './styles/Display.scss';

// these breakpoints need to match the ones in Display.scss
type Breakpoint = '1200' | '1024' | '480';

type Props = {
  children: any;
  className?: string;
  hide?: Breakpoint;
  inline?: boolean;
  show?: Breakpoint;
  eventKey?: string;
};

type State = {
  visible: boolean;
};

export default class Display extends React.Component<Props, State> {
  displayInput: React.RefObject<HTMLDivElement>;

  constructor(props: Props) {
    super(props);
    this.displayInput = React.createRef<HTMLDivElement>();
    this.state = {
      visible: false,
    };
  }

  componentDidMount() {
    const { eventKey } = this.props;
    if (eventKey) {
      this.updateVisibility();
    }
    if (eventKey && this.state.visible) {
      EventTracking.trackKey(eventKey);
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.eventKey) {
      this.updateVisibility();
    }
    if (prevState.visible !== this.state.visible && this.state.visible && this.props.eventKey) {
      EventTracking.trackKey(this.props.eventKey);
    }
  }

  getDisplayVisibility = (): boolean => {
    if (this.displayInput.current) {
      const isInvisible =
        this.displayInput.current.offsetHeight === 0 && this.displayInput.current.offsetWidth === 0;
      return !isInvisible;
    }
    return false;
  };

  updateVisibility = throttle(() => {
    this.setState({ visible: this.getDisplayVisibility() });
  }, 200);

  render() {
    const { hide, show, inline, children, className } = this.props;

    if (!hide && !show) {
      return children;
    }

    return (
      <div
        className={cx(
          'Display',
          hide && `Display--hide--${hide}`,
          inline && 'Display--inline',
          show && 'Display--show',
          show && `Display--show--${show}`,
          className
        )}
        ref={this.displayInput}>
        {children}
      </div>
    );
  }
}
